import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTags } from "@fortawesome/free-solid-svg-icons";
import { categories } from "../../config/categories";
import { useEffect, useRef, useState } from "react";
import "./NavCategorias.css";

const API_URL = import.meta.env.VITE_API_URL;

function NavCategorias() {
  const [brands, setBrands] = useState([]);
  const [searchBrand, setSearchBrand] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const togglerRef = useRef(null);
  const dropdownRef = useRef(null);
  const location = useLocation();

  const isMobile = () => window.innerWidth < 992;
  const MAX_BRANDS = 20;

  // cerrar con Escape
  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") {
        setOpenDropdown(null);
        setIsOpen(false);
      }
    }
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  // 🔍 filtro completo
  const allFilteredBrands = brands.filter((brand) =>
    brand.name.toLowerCase().includes(searchBrand.toLowerCase())
  );

  // 🎯 limitación inteligente
  const filteredBrands = searchBrand
    ? allFilteredBrands
    : allFilteredBrands.slice(0, MAX_BRANDS);

  const hasMoreBrands = allFilteredBrands.length > MAX_BRANDS;

  // 📡 fetch
  useEffect(() => {
    fetch(`${API_URL}/stock/brands`)
      .then((res) => res.json())
      .then((data) => setBrands(Array.isArray(data) ? data : []))
      .catch((err) => console.error("Error al cargar marcas:", err));
  }, []);

  // 🔄 cambio de ruta
  useEffect(() => {
  if (window.innerWidth >= 992) {
    // 🖥 desktop → cerrar todo
    setIsOpen(false);
    setOpenDropdown(null);
  } else {
    // 📱 mobile → mantener menú abierto
    setOpenDropdown(null); // solo cerrar dropdown
  }
}, [location]);

  // ❌ click afuera
  useEffect(() => {
  function handleClickOutside(e) {
    const isInsideDropdown =
      dropdownRef.current && dropdownRef.current.contains(e.target);

    const isToggler =
      togglerRef.current && togglerRef.current.contains(e.target);

    const isNavClick = e.target.closest(".nav-link") || e.target.closest(".dropdown-item");

    // ❌ si es click dentro del menú, NO cierres nada
    if (isInsideDropdown || isToggler || isNavClick) return;

    setOpenDropdown(null);
    setIsOpen(false);
  }

  document.addEventListener("pointerdown", handleClickOutside);
  return () => document.removeEventListener("pointerdown", handleClickOutside);
}, []);

  const toggleMenu = () => setIsOpen((v) => !v);

  const toggleDropdown = (id) => {
    setOpenDropdown((curr) => {
      if (curr === id) return null;
      if (id === "brands") setSearchBrand("");
      return id;
    });
  };

  // 📱 FIX MOBILE UX
  const closeMenu = () => {
  setOpenDropdown(null);

  if (window.innerWidth >= 992) {
    setIsOpen(false);
  }
};

  return (
    <nav className="navbar navbar-expand-lg navbar-dark nav-categorias-navbar" role="navigation" aria-label="Navegación de categorías">
      <div className="container-fluid px-4">

        {/* MOBILE HEADER */}
        <div className="d-lg-none d-flex justify-content-between align-items-center w-100 mb-2">
          <span className="explore-text">🌟 Explora nuestras categorías</span>
          <button
            ref={togglerRef}
            type="button"
            className="navbar-toggler"
            aria-expanded={isOpen}
            aria-controls="nav-categorias-collapse"
            aria-label={isOpen ? "Cerrar categorías" : "Abrir categorías"}
            onClick={toggleMenu}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
        </div>

        {/* MENU */}
        <div
          className={`navbar-collapse navbar-collapse-custom ${isOpen ? "show" : ""}`}
          id="nav-categorias-collapse"
        >
          <ul className="navbar-nav w-100 categories-row" role="menubar">

            {/* ================= MARCAS ================= */}
            <li
              className={`nav-item dropdown nav-item-brand ${openDropdown === "brands" ? "open-dropdown" : ""}`}
              ref={openDropdown === "brands" ? dropdownRef : null}
            >
              <button
                className="nav-link dropdown-toggle highlighted-nav"
                onClick={() => toggleDropdown("brands")}
                aria-haspopup="true"
                aria-expanded={openDropdown === "brands"}
                id="nav-brands-btn"
              >
                <FontAwesomeIcon icon={faTags} className="me-2" />
                Marcas
              </button>

              <div className={`dropdown-menu dropdown-menu-brands ${openDropdown === "brands" ? "show" : ""}`} role="menu" aria-labelledby="nav-brands-btn">
                <div className="dropdown-brands-wrapper">

                  {/* 🔍 BUSCADOR */}
                  <div className="brand-search-container">
                    <input
                      type="text"
                      placeholder="Buscar marca..."
                      value={searchBrand}
                      onChange={(e) => setSearchBrand(e.target.value)}
                      className="brand-search-input"
                    />
                  </div>

                  {/* 📦 LISTA CON SCROLL */}
                  <div className="dropdown-brands-list">
                    {filteredBrands.length > 0 ? (
                      <div className="brands-grid">
                        {filteredBrands.map((brand) => (
                          <Link
                            key={brand.id}
                            className="dropdown-item"
                            to={`/marcas/${brand.name.toLowerCase().replace(/\s+/g, "-")}`}
                            onClick={closeMenu}
                            role="menuitem"
                          >
                            {brand.name}
                          </Link>
                        ))}
                      </div>
                    ) : (
                      <div className="text-muted px-3 py-2">
                        No se encontraron marcas
                      </div>
                    )}
                  </div>

                  {/* 🔗 BOTÓN SIEMPRE PRESENTE */}
                  <div className="see-more-brands-container">
                    {hasMoreBrands ? (
                      <Link
                        to="/marcas"
                        className="see-more-brands-btn"
                        onClick={closeMenu}
                      >
                        Ver todas las marcas → ({brands.length})
                      </Link>
                    ) : (
                      <span className="see-more-brands-btn disabled">
                        No hay más marcas
                      </span>
                    )}
                  </div>

                </div>
              </div>
            </li>

            {/* ================= CATEGORÍAS ================= */}
            {categories.map((category) => (
              <li
                key={category.id}
                className={`nav-item dropdown nav-item-category ${openDropdown === category.id ? "open-dropdown" : ""}`}
                ref={openDropdown === category.id ? dropdownRef : null}
              >
                <button
                  className="nav-link dropdown-toggle category-btn"
                  onClick={() => toggleDropdown(category.id)}
                  aria-haspopup="true"
                  aria-expanded={openDropdown === category.id}
                  id={`nav-cat-${category.id}`}
                >
                  <FontAwesomeIcon icon={category.icon} className="me-2" />
                  {category.name}
                </button>

                <ul className={`dropdown-menu category-dropdown-menu ${openDropdown === category.id ? "show" : ""}`} role="menu" aria-labelledby={`nav-cat-${category.id}`}>
                  {category.subcategories.map((sub) => (
                    <li key={sub.id}>
                      <Link
                        className="dropdown-item"
                        to={`/tienda/${sub.id}`}
                        onClick={closeMenu}
                        role="menuitem"
                      >
                        {sub.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
            ))}

          </ul>
        </div>
      </div>
    </nav>
  );
}

export default NavCategorias;